"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReCaptchaLoader_1 = require("./ReCaptchaLoader");
exports.load = ReCaptchaLoader_1.load;
exports.getInstance = ReCaptchaLoader_1.getInstance;
var ReCaptchaInstance_1 = require("./ReCaptchaInstance");
exports.ReCaptchaInstance = ReCaptchaInstance_1.ReCaptchaInstance;
